import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

function StatsCard({ ...props }) {
  const { description, statLink, small, statText, iconColor, statIconColor, icon } = props;
  return (
    <Card
      icon={icon}
      iconColor={iconColor}
      actions={<div>{statLink !== undefined ? <a href={statLink.href}>{statLink.text}</a> : statText !== undefined ? statText : null}</div>}
      footer={
        <Grid container gap={1} alignItems='center'>
          <props.statIcon color={`${statIconColor}`} />
          {statLink !== undefined ? <a href={statLink.href}>{statLink.text}</a> : statText !== undefined ? statText : null}
        </Grid>
      }
      footerProps={{ sx: theme => ({ paddingTop: theme.spacing(0), paddingBottom: theme.spacing(1) }) }}
    >
      <Typography variant='h6' component='h2' sx={{ textAlign: 'right' }}>
        {description} {small !== undefined ? <small>{small}</small> : null}
      </Typography>
      <Divider sx={{ padding: 0, margin: 0 }} />
    </Card>
  );
}

StatsCard.defaultProps = {
  iconColor: 'primary',
  statIconColor: 'disabled'
};

StatsCard.propTypes = {
  icon: PropTypes.object.isRequired,
  iconColor: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error', 'rose']),
  title: PropTypes.node,
  description: PropTypes.node,
  small: PropTypes.node,
  statIcon: PropTypes.object.isRequired,
  statIconColor: PropTypes.oneOf(['disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
  statLink: PropTypes.object,
  statText: PropTypes.node
};

export default StatsCard;
